// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  firebaseConfig: {
    apiKey: 'AIzaSyDDa6NQR5_9z95iN6oTVO5dVNdwwJ4VCYw',
    authDomain: 'huzaifaanjum-1e492.firebaseapp.com',
    databaseURL: 'https://huzaifaanjum-1e492.firebaseio.com',
    projectId: 'huzaifaanjum-1e492',
    storageBucket: 'huzaifaanjum-1e492.appspot.com',
    messagingSenderId: '245859763597',
    appId: '1:245859763597:web:46ff02fa9723fd4b0ba9c4',
    measurementId: 'G-RJR0L3S1H8'
  },
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  firebaseConfigPortfolio: {
    apiKey: 'AIzaSyAd2JU6oX8nrh_Td8sqIPV7HLkiGijsWDk',
    authDomain: 'huzaifaanjumportfolio.firebaseapp.com',
    databaseURL: 'https://huzaifaanjumportfolio.firebaseio.com',
    projectId: 'huzaifaanjumportfolio',
    storageBucket: 'huzaifaanjumportfolio.appspot.com',
    messagingSenderId: '448995397394',
    appId: '1:448995397394:web:14f7f3cc8278ed1fa3adcb',
    measurementId: 'G-3612MQVFS4'
  },
  gsRefpath: 'gs://huzaifaanjumportfolio.appspot.com/huzaifa.pdf'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
